module.exports = {
    API_URL: "https://eth-auth.herokuapp.com" //process.env.REACT_APP_API_URL
};